import moment from "moment";
import { convertToRupiah } from "../../../../helper/Rupiah";

const TableItem = ({ data, no, editHandler }) => {
  if (!data) return null;

  const dueDate = data.due_date ? moment(data.due_date).format("DD/MM/YYYY") : "-";
  const paymentDate = data.payment_date ? moment(data.payment_date).format("DD/MM/YYYY") : "-";
  const amount = data.amount || 0;
  const duration = data.duration || "-";
  const status = data.status || "Belum Lunas";

  const isPaid = status.toLowerCase() === "lunas";
  const paymentStatusClass = isPaid ? "fw-bold text-success" : "fw-bold text-danger";

  return (
    <tr>
      <td>{no + 1}</td>
      <td>{dueDate}</td>
      <td>{paymentDate}</td>
      <td>Rp. {convertToRupiah(amount)}</td>
      <td>{duration}</td>
      <td className={paymentStatusClass}>{status}</td>
    </tr>
  );
};

export default TableItem;
